import { BehaviorSubject, Observable } from 'rxjs';
import { TogetherBaseAddress } from '../models/api.models';
import { FullAddress } from '../models/address.models';
import { Injectable } from '@angular/core';
/**
 * 
 * 
 * @export
 * @class AddressComponentService
 */
@Injectable()
export class AddressComponentService {
  /**
   * 
   * 
   * @type {FullAddress}
   * @memberof AddressComponentService
   */
  qasAddress: FullAddress = new FullAddress();

  /**
   * 
   * 
   * @type {TogetherBaseAddress}
   * @memberof AddressComponentService
   */
  address: TogetherBaseAddress = new TogetherBaseAddress();
  
  /**
   * 
   * 
   * @type {number}
   * @memberof AddressComponentService
   */
  editMode: number = 0;

  /**
   * 
   * 
   * @type {BehaviorSubject<any>}
   * @memberof AddressComponentService
   */
  controlMode : BehaviorSubject<any>;

  /**
   * 
   * 
   * @readonly
   * @type {string}
   * @memberof AddressComponentService
   */
  get ControlMode(): string {
    return this.controlMode.getValue();
  }

  /**
   * Creates an instance of AddressComponentService.
   * @memberof AddressComponentService
   */
  constructor() {
    this.controlMode = new BehaviorSubject('');
  }
}
